/** Bundles sold at one price. */
const packs = {
  en: {
    title: "Packs",
    subtitle: "Bundles sold at one price. Selling one takes each item out of your stock.",
    new: "New pack",
    loadFailed: "Could not load your packs.",
    saveFailed: "Could not save that pack.",
    name: "Name",
    price: "Pack price ({currency})",
    soldSeparately: "Sold separately: {list} — a saving of {saving}",
    contents: "What is in it",
    searchProduct: "Search a product or a range to add…",
    anyVariant: "any variant",
    slotHint:
      "A range is a choice: when the pack is sold, the cashier picks which variant the customer wants, and that one comes out of stock.",
    save: "Save pack",
    none: "No packs yet.",
    cannotMake: "cannot be made up",
    canMake: { one: "{count} can be made", other: "{count} can be made" },
    inStock: "({count} in stock)",
    removeItem: "Remove {name}",
    belowCost:
      "Sells for less than its contents cost you ({cost}). It can still be sold.",
  },

  fr: {
    title: "Packs",
    subtitle:
      "Des lots vendus à prix unique. Chaque vente retire chaque article de votre stock.",
    new: "Nouveau pack",
    loadFailed: "Impossible de charger vos packs.",
    saveFailed: "Impossible d'enregistrer ce pack.",
    name: "Nom",
    price: "Prix du pack ({currency})",
    soldSeparately: "Vendus séparément : {list} — une économie de {saving}",
    contents: "Contenu",
    searchProduct: "Rechercher un produit ou une gamme à ajouter…",
    anyVariant: "au choix",
    slotHint:
      "Une gamme est un choix : à la vente du pack, le caissier choisit la variante voulue par le client, et c'est celle-là qui sort du stock.",
    save: "Enregistrer le pack",
    none: "Aucun pack pour l'instant.",
    cannotMake: "impossible à composer",
    canMake: {
      one: "{count} peut être composé",
      other: "{count} peuvent être composés",
    },
    inStock: "({count} en stock)",
    removeItem: "Retirer {name}",
    belowCost:
      "Vendu moins cher que ce que son contenu vous coûte ({cost}). Il reste vendable.",
  },

  ar: {
    title: "الباقات",
    subtitle: "مجموعات تُباع بسعر واحد. بيع باقة يُخرج كل منتج فيها من مخزونك.",
    new: "باقة جديدة",
    loadFailed: "تعذّر تحميل باقاتك.",
    saveFailed: "تعذّر حفظ هذه الباقة.",
    name: "الاسم",
    price: "سعر الباقة ({currency})",
    soldSeparately: "بالتفصيل: {list} — توفير {saving}",
    contents: "محتوى الباقة",
    searchProduct: "ابحث عن منتج أو مجموعة لإضافتها…",
    anyVariant: "أي نوع",
    slotHint:
      "المجموعة اختيار: عند بيع الباقة يختار البائع النوع الذي يريده الزبون، ويخرج ذلك النوع من المخزون.",
    save: "حفظ الباقة",
    none: "لا توجد باقات بعد.",
    cannotMake: "لا يمكن تكوينها",
    canMake: {
      one: "يمكن تكوين باقة واحدة",
      two: "يمكن تكوين باقتين",
      few: "يمكن تكوين {count} باقات",
      other: "يمكن تكوين {count} باقة",
    },
    inStock: "({count} في المخزون)",
    removeItem: "إزالة {name}",
    belowCost: "تُباع بأقل من تكلفة محتواها ({cost}). يبقى بيعها ممكناً.",
  },
};

export default packs;
